document.addEventListener('click', (event) => {
  const button = event.target.closest('.load-more-fragances');
  if (!button) return;

  const card = button.closest('.card-wrapper');
  const extraBullets = card.querySelectorAll('.extra-bullet');

  extraBullets.forEach(bullet => {
    bullet.style.display = 'flex';
  });

  button.style.display = 'none';
});
